

angular.module("cimerFrontEndApp")
    .controller("CuratedQuestionsCtrl",
    [
        "$scope", "$q", "SurveyService", "Session", "$uibModal", "$location", "TextEditorService",
        function ($scope, $q, SurveyService, Session, $uibModal, $location, TextEditorService) {

            'use strict';

            var adminPageUrl = '/baseSurveys';
                    
            var sessionObject = Session.getSessionObject();
            if (!sessionObject.isAuthenticated || !(sessionObject.isAdmin || sessionObject.isProjectAdmin)) {
                $location.url('/');
                return;
            }

            var dataRequests = [SurveyService.getCuratedQuestionGroupsForAdmin(), SurveyService.getTargets(), SurveyService.getProjectsWhereUserIsAdmin(), SurveyService.getCuratedSectionTags()];
            //load requested data
            $q.all(dataRequests)
                .then(function (data) {
                    $scope.allCuratedQuestions = data[0];
                    $scope.curatedQuestions = data[0];  // initially show all curated questions
                    $scope.targets = data[1];
                    $scope.projects = data[2];
                    $scope.tags = data[3];
                });

            

            $scope.buildingSection = false;
            $scope.showCompositeScore = false;
            $scope.section = {
                Projects: [],  // this is required to prevent console errors from the binding on the ng-dropdown-multiselect
                Tags: []  // this is required to prevent console errors from the binding on the ng-dropdown-multiselect
            };
            $scope.formSubmitted = false;
            $scope.compositeScores = [];
            $scope.tinymceOptions = TextEditorService.GetTextEditorConfig();
            $scope.isAdmin = sessionObject.isAdmin;
            $scope.moreInfoLength = 0;
            $scope.moreInfoMaxLength = 500;
            $scope.sectionTitleMaxLength = 255;

            $scope.filterTags = [];
            $scope.tagDropdownSettings = {
                externalIdProp: '',
                idProp: 'TagId',
                displayProp: 'Name',
                showCheckAll: false,
                smartButtonMaxItems: 3,
                template: '<span ng-attr-title="{{option.Name}}">{{option.Name}}</span>',
                buttonClasses: 'btn btn-default'
            };
            $scope.tagFilterEvents = {
                onSelectionChanged: function () {
                    $scope.filterQuestionGroups();
                }
            };

            $scope.projectDropdownSettings = {
                externalIdProp: '',
                idProp: 'ProjectId',
                displayProp: 'DisplayName',
                showCheckAll: false,
                smartButtonMaxItems: 3,
                template: '<span ng-attr-title="{{option.DisplayName}}">{{option.DisplayName}}</span>',
                buttonClasses: 'btn btn-default'
            };

            $scope.createNewSection = function() {
                $scope.buildingSection = true;
                $scope.moreInfoLength = 0;
                $scope.section = {
                    questions: [],
                    sectionTitle: "",
                    sectionName: '<p>Add new section name here</p>', // placeholder text
                    TargetID: null,
                    SectionRoleID: 2,
                    MoreInformation: "",
                    Projects: [],
                    Tags: [],
                    status: 'New'
                };
            };

            $scope.returnToList = function() {
                $scope.buildingSection = false;
                $scope.showCompositeScore = false;
                $scope.section = {
                    Projects: [],  // this is required to prevent console errors from the binding on the ng-dropdown-multiselect
                    Tags: []  // this is required to prevent console errors from the binding on the ng-dropdown-multiselect
                };
                $scope.formSubmitted = false;
                $scope.compositeScores = [];
            };

            $scope.editQuestionGroup = function (questionGroup) {
                if (!$scope.isAdmin) { return; }
                SurveyService.loadCuratedQuestionGroup(questionGroup.SectionID).then(function (result) {

                    $scope.buildingSection = true;
                    $scope.section = {
                        questions: SurveyService.parseQuestionPrompts(result.QuestionPrompts),
                        sectionTitle: result.SectionTitle,
                        sectionName: result.SectionText,
                        TargetID: null, // logic to determine this changes based on the first question type, fill this in below
                        SectionID: result.SectionID,
                        SectionRoleID: result.SectionRoleID,
                        MoreInformation: result.MoreInformation,
                        Projects: result.Projects,
                        Tags: result.Tags,
                        status: questionGroup.CuratedQuestionSectionStatus
                    };

                    // If the first question is a matrix question, we need to go down a level to find the TargetID (mentor/mentee)
                    if (result.QuestionPrompts[0].hasOwnProperty('Questions')) {
                        $scope.section.TargetID = result.QuestionPrompts[0].Questions[0].TargetID;
                    }
                    // Otherwise we can get the target info right off of the question prompt
                    else {
                        $scope.section.TargetID = result.QuestionPrompts[0].TargetID;
                    }
                    if ($scope.section.status === 'Released') {
                        $scope.previewSection = $scope.prepSectionForPreview().Sections[0];
                    }
                    $scope.checkLength();

                }, function (err) {

                });
            };

            $scope.releaseQuestionGroup = function (id) {
                if (!$scope.isAdmin) { return; }
                SurveyService.updateCuratedQuestionGroupStatus(id, SurveyService.CuratedSectionStatus.Released)
                    .then(function(result) {
                        if (result) {
                            SurveyService.getCuratedQuestionGroupsForAdmin().then(function (result) {
                                $scope.allCuratedQuestions = result;
                                $scope.filterQuestionGroups();
                            });                             
                        }
                    });
            };

            $scope.deleteQuestionGroup = function (id) {
                if (!$scope.isAdmin) { return; }
                SurveyService.updateCuratedQuestionGroupStatus(id, SurveyService.CuratedSectionStatus.Deleted)
                    .then(function (result) {
                        if (result) {
                            SurveyService.getCuratedQuestionGroupsForAdmin().then(function (result) {
                                $scope.allCuratedQuestions = result;
                                $scope.filterQuestionGroups();
                            });
                        }
                    });
            };

            $scope.addCompositeScore = function () {
                if (!$scope.isAdmin) { return; }
                if (!$scope.hasOwnProperty('compositeScores') || $scope.compositeScores === undefined) {
                    $scope.compositeScores = [];
                }
                SurveyService.getCuratedQuestionsForCompositeScore($scope.section.SectionID)
                    .then(function (result) {
                        $scope.compositeScores.push({
                            compositeScoreName: '',
                            selectedQuestions: [],
                            allQuestions: SurveyService.parseQuestionsForCompositeScore(result)
                        });
                    });
            };

            $scope.editCompositeScore = function (sectionId) {
                SurveyService.getCuratedCompositeScoresForEdit(sectionId)
                    .then(function (result) {
                        var tempObj = {};
                        for (var i = 0; i < result.CompositeScores.length; i++) {
                            tempObj = {
                                compositeScoreName: result.CompositeScores[i].Name,
                                compositeScoreID: result.CompositeScores[i].CompositeScoreID,
                                allQuestions: SurveyService.parseQuestionsForCompositeScore(result.CompositeScores[i].AllQuestions),
                                selectedQuestions: SurveyService.parseQuestionsForCompositeScore(result.CompositeScores[i].SelectedQuestions)
                            };
                            $scope.compositeScores.push(tempObj);
                        }
                        $scope.section = {
                            SectionID: sectionId,
                            Projects: [],  // this is required to prevent console errors from the binding on the ng-dropdown-multiselect
                            Tags: []  // this is required to prevent console errors from the binding on the ng-dropdown-multiselect
                        };
                        $scope.buildingSection = false;
                        $scope.showCompositeScore = true;
                    });
            };

            $scope.removeCompositeScore = function (index) {
                if (!$scope.isAdmin) { return; }
                $scope.compositeScores.splice(index, 1);
            };

            $scope.saveCompositeScores = function () {

                if (!$scope.isAdmin) { return; }
                $scope.formSubmitted = true;

                if (!$scope.compositeScoresForm.$invalid) { // we can submit
                    $scope.savePressed = true;
                    // format for save
                    var surveyCompositeScore = {
                        //BaseSurveyID: $scope.baseSurvey.SurveyID,
                        SectionID: $scope.section.SectionID,
                        CompositeScores: []
                    };
                    var tempObj = {};
                    var tempQuestion = {};
                    for (var i = 0; i < $scope.compositeScores.length; i++) {
                        var compositeScore = $scope.compositeScores[i];
                        tempObj = {
                            CompositeScoreID: compositeScore.compositeScoreID,
                            Name: compositeScore.compositeScoreName,
                            Questions: []
                        };
                        for (var j = 0; j < compositeScore.selectedQuestions.length; j++) {
                            tempQuestion = {
                                QuestionID: compositeScore.selectedQuestions[j].details.QuestionID
                            };
                            tempObj.Questions.push(tempQuestion);
                        }
                        surveyCompositeScore.CompositeScores.push(tempObj);
                    }

                    //submit composite scores
                    SurveyService.saveCuratedCompositeScores(surveyCompositeScore).then(function (result) {
                        $scope.curatedQuestions.forEach(function (questionGroup) {
                            if (questionGroup.SectionID === $scope.section.SectionID) {
                                if (surveyCompositeScore.CompositeScores.length > 0) {
                                    questionGroup.HasCompositeScore = true;
                                }
                                else {
                                    questionGroup.HasCompositeScore = false;
                                }
                            }
                        });
                        $scope.returnToList();
                        $scope.savePressed = false;
                    }, function (err) {
                        $location.path('error');
                    });

                }
            };

            $scope.saveQuestion = function () {

                if (!$scope.isAdmin) { return; }
                $scope.formSubmitted = true;
                
                if (!$scope.newQuestionGroupForm.$invalid) {  //valid for submission

                    var sectionID = null;
                    if ($scope.section.hasOwnProperty("SectionID")) { //editing existing section
                        sectionID = $scope.section.SectionID;
                    }

                    var tempObj = {
                        SectionID: sectionID, 
                        SectionTitle: $scope.section.sectionTitle,
                        SectionText: $scope.section.sectionName,
                        SectionSortOrder: 1,
                        SectionRoleID: SurveyService.QuestionRole.Curated, // curated section
                        Questions: [],
                        CuratedSectionStatusID: $scope.section.status === 'New' ? SurveyService.CuratedSectionStatus.New : SurveyService.CuratedSectionStatus.Released,
                        MoreInformation: $scope.section.MoreInformation,
                        Projects: $scope.section.Projects,
                        Tags: $scope.section.Tags
                    };

                    var sortOrder = 1;
                    var question, tempQuestion;
                    //loop through questions and set curated role,  and further parse matrix questions
                    for (var j = 0; j < $scope.section.questions.length; j++) {


                        //if it is a matrix question, need another loop
                        if ($scope.section.questions[j].details.hasOwnProperty('Questions')) {
                            for (var k = 0; k < $scope.section.questions[j].details.Questions.length; k++) {
                                question = $scope.section.questions[j].details.Questions[k];
                                tempQuestion = {
                                    QuestionID: question.QuestionID,
                                    SectionIndexID: question.SectionIndexID,
                                    SortOrder: sortOrder,
                                    TargetID: $scope.section.TargetID,  //specifically chosen on curated question group
                                    QuestionScale: {
                                        QuestionScaleID: question.QuestionScaleID,
                                        OwnerID: question.OwnerID,
                                        Answers: question.QuestionScale
                                    },
                                    QuestionTypeID: question.QuestionTypeID,
                                    Text: question.Text,
                                    QuestionLabel: question.QuestionLabel,
                                    QuestionPromptID: $scope.section.questions[j].details.QuestionPromptID,
                                    QuestionPromptText: $scope.section.questions[j].details.QuestionPromptText,
                                    QuestionRoleID: SurveyService.QuestionRole.Curated,
                                    MatrixQuestionGroup: j.toString(), // current matrix group. The backend maps this to a string property for some reason
                                    QuestionBranchIDs: [],
                                    Required: false // this isn't an option for matrix so default to false
                                };

                                for (var l = 0; l < question.QuestionBranches.length; l++) {
                                    for (var m = 0; m < question.QuestionBranches[l].ParentQuestions.length; m++) {
                                        tempQuestion.QuestionBranchIDs.push(question.QuestionBranches[l].ParentQuestions[m].ScaleAnswers.map(sa => sa.QuestionBranch.getID()));
                                    }
                                }
                                tempQuestion.QuestionBranchIDs = tempQuestion.QuestionBranchIDs.flat();

                                // Add branch IDs to scale objects
                                for (var n = 0; n < question.QuestionScale.length; n++) {
                                    tempQuestion.QuestionScale.Answers[n].TempBranchID = question.QuestionScale[n].QuestionBranch.TempBranchID;
                                }

                                tempObj.Questions.push(tempQuestion);
                                sortOrder++;
                            }
                        }
                            //otherwise just add the question
                        else {
                            question = $scope.section.questions[j].details;
                            tempQuestion = {
                                QuestionID: question.QuestionID,
                                SectionIndexID: question.SectionIndexID,
                                SortOrder: sortOrder,
                                TargetID: $scope.section.TargetID,   //specifically chosen on curated question group
                                QuestionScale: {
                                    QuestionScaleID: question.QuestionScaleID,
                                    OwnerID: question.OwnerID,
                                    Answers: question.QuestionScale
                                },
                                QuestionTypeID: question.QuestionTypeID,
                                Text: question.Text,
                                QuestionLabel: question.QuestionLabel,
                                QuestionPromptID: question.QuestionPromptID,
                                QuestionPromptText: '',
                                QuestionRoleID: SurveyService.QuestionRole.Curated,
                                QuestionBranchIDs: [],
                                Required: question.Required
                            };

                            for (var l = 0; l < question.QuestionBranches.length; l++) {
                                for (var m = 0; m < question.QuestionBranches[l].ParentQuestions.length; m++) {
                                    tempQuestion.QuestionBranchIDs.push(question.QuestionBranches[l].ParentQuestions[m].ScaleAnswers.map(sa => sa.QuestionBranch.getID()));
                                }
                            }
                            tempQuestion.QuestionBranchIDs = tempQuestion.QuestionBranchIDs.flat();

                            // Add branch IDs to scale objects
                            for (var n = 0; n < question.QuestionScale.length; n++) {
                                tempQuestion.QuestionScale.Answers[n].TempBranchID = question.QuestionScale[n].QuestionBranch.TempBranchID;
                            }

                            tempObj.Questions.push(tempQuestion);
                            sortOrder++;
                        }
                    }
                    //end parse questions

                    //submit here
                    SurveyService.saveCuratedQuestionGroup(tempObj).then(function(result) {
                        if (!result) { $location.path('error'); return; }
                        //refresh question groups
                        SurveyService.getCuratedQuestionGroupsForAdmin().then(function (result) {
                            $scope.allCuratedQuestions = result;
                            $scope.filterQuestionGroups();
                            $scope.returnToList();
                        });

                    }, function(err) {
                        $location.path('error');
                    });


                }
     
            };

            $scope.back = function () {
                $location.url(adminPageUrl);
            };

            $scope.previewSectionFromMainView = function (sectionID) {
                SurveyService.loadCuratedQuestionGroup(sectionID).then(function (result) {

                    $scope.section = {
                        questions: SurveyService.parseQuestionPrompts(result.QuestionPrompts),
                        sectionTitle: result.SectionTitle,
                        sectionName: result.SectionText,
                        TargetID: null, // logic to determine this changes based on the first question type, fill this in below
                        SectionID: result.SectionID,
                        Projects: [],  // this is required to prevent console errors from the binding on the ng-dropdown-multiselect
                        Tags: []  // this is required to prevent console errors from the binding on the ng-dropdown-multiselect
                    };

                    // If the first question is a matrix question, we need to go down a level to find the TargetID (mentor/mentee)
                    if (result.QuestionPrompts[0].hasOwnProperty('Questions')) {
                        $scope.section.TargetID = result.QuestionPrompts[0].Questions[0].TargetID;
                    }
                    // Otherwise we can get the target info right off of the question prompt
                    else {
                        $scope.section.TargetID = result.QuestionPrompts[0].TargetID;
                    }
                    // show the preview
                    $scope.previewSectionModal();
                }, function (err) {

                });
            };

            $scope.previewSectionModal = function () {

                var survey = $scope.prepSectionForPreview();
                
                var previewSurveyModalInstance = $uibModal.open({
                    animation: true,
                    templateUrl: '/Content/Templates/survey/previewSurveyModal.html',
                    controller: 'PreviewSurveyModalCtrl',
                    size: 'lg',
                    resolve: {
                        survey: function () {
                            return survey;
                        }
                    }
                });

            };

            $scope.prepSectionForPreview = function () {
                var survey = {};
                var tempObj = {};

                survey.SurveyName = "Curated Question Group";
                survey.Sections = [];


                //get last questionCount number
                var questionCount = 1;

                //add custom Sections and renumber for newly added questions
                tempObj = {
                    SectionTitle: $scope.section.sectionTitle,
                    SectionText: $scope.section.sectionName,
                    SectionSortOrder: 1,
                    QuestionPrompts: []
                };
                for (var j = 0; j < $scope.section.questions.length; j++) {
                    $scope.section.questions[j].details.questionCount = questionCount;
                    if ($scope.section.questions[j].details.hasOwnProperty('Questions')) {
                        for (var k = 0; k < $scope.section.questions[j].details.Questions.length; k++) {
                            $scope.section.questions[j].details.Questions[k].promptCount = k + 1;
                        }
                    }
                    tempObj.QuestionPrompts.push($scope.section.questions[j].details);
                    questionCount++;
                }
                survey.Sections.push(tempObj);
                return survey;
            };

            $scope.checkLength = function () {
                var tx = TextEditorService.ConvertToPlainTextSync($scope.section.MoreInformation);
                if (!tx) {
                    $scope.moreInfoLength = 0;
                }
                $scope.moreInfoLength = tx.length;
                if ($scope.moreInfoLength > 500) {
                    $scope.newQuestionGroupForm.moreInfo.$setValidity("moreInfo", false);
                }
                else {
                    $scope.newQuestionGroupForm.moreInfo.$setValidity("moreInfo", true);
                }
            };

            $scope.filterQuestionGroups = function () {
                if (!$scope.filterProject && !$scope.filterTags) {
                    $scope.curatedQuestions = $scope.allCuratedQuestions;
                    return;
                }               
                $scope.curatedQuestions = []; // clear the display list
                var projectGroupFilteredList = []
                var currentFilteredQuestionList = $scope.allCuratedQuestions;  // start this with all the questions
                if ($scope.filterProject) {

                    for (var i = 0; i < currentFilteredQuestionList.length; i++) {
                        for (var m = 0; m < currentFilteredQuestionList[i].Projects.length; m++) {
                            if (currentFilteredQuestionList[i].Projects[m].ProjectId === $scope.filterProject.ProjectId) {
                                projectGroupFilteredList.push(currentFilteredQuestionList[i]);
                                break;
                            }
                        }
                    }
                    currentFilteredQuestionList = projectGroupFilteredList; //we've filtered this list, use this for any tag filtering next
                }
                var tagFilteredList = [];
                if ($scope.filterTags && $scope.filterTags.length > 0) {
                    for (var j = 0; j < currentFilteredQuestionList.length; j++) {
                        var question = currentFilteredQuestionList[j];
                        var addQuestion = true;
                        for (var l = 0; l < $scope.filterTags.length; l++) {
                            var foundTag = false;
                            for (var k = 0; k < question.Tags.length; k++) {                          
                                if (question.Tags[k].TagId === $scope.filterTags[l].TagId) {
                                    foundTag = true;    // we need to find all the tags in the filter list on this question to be able to add it
                                    break;
                                }
                            }
                            if (!foundTag) {  // we didn't find the filter tag, move to the next question
                                addQuestion = false;
                                break;
                            }
                        }
                        if (addQuestion) {
                            tagFilteredList.push(question);
                        }
                    }
                    currentFilteredQuestionList = tagFilteredList; // we've filtered this list, assign it to the current question list
                }
                $scope.curatedQuestions = currentFilteredQuestionList;
            };

            $scope.projectFilterQuestionGroups = function (filterProject) {
                $scope.filterProject = filterProject;
                $scope.filterQuestionGroups();
            };

        }
    ]);